<ng-container *transloco="let t; prefix: 'trip-finances.panels.participant-payment'">
  <app-panel-body>
    <form class="flex min-h-0 flex-1 flex-col" [formGroup]="form" (ngSubmit)="save()">
      <div class="min-h-0 flex-1 overflow-y-auto">
        <app-content-container>
          <div class="space-y-4">
            <div>
              <label class="mb-1 block text-sm font-medium" for="payment-type">{{ t('type') }}</label>
              <select
                id="payment-type"
                class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm"
                formControlName="type"
              >
                @for (opt of paymentTypes; track opt.value) {
                  <option [ngValue]="opt.value">{{ t(opt.labelKey) }}</option>
                }
              </select>
            </div>

            <div>
              <label class="mb-1 block text-sm font-medium" for="payment-description">{{ t('description') }}</label>
              <input
                id="payment-description"
                type="text"
                class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm"
                formControlName="description"
              />
            </div>

            <div>
              <label class="mb-1 block text-sm font-medium" for="payment-due">{{ t('due-date') }}</label>
              <input
                id="payment-due"
                type="date"
                class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm"
                formControlName="due"
              />
            </div>

            <div>
              <label class="mb-1 block text-sm font-medium" for="payment-amount">{{ t('amount') }}</label>
              <input
                id="payment-amount"
                type="number"
                min="0.01"
                step="0.01"
                class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm"
                formControlName="payment"
              />
            </div>
          </div>
        </app-content-container>
      </div>

      <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
        <button type="button" class="rounded-md border border-primary-border px-4 py-2 text-sm font-semibold" (click)="cancel()" [disabled]="submitting()">
          {{ t('cancel') }}
        </button>
        <button type="submit" class="btn btn-primary btn-no-grow disabled:opacity-50" [disabled]="submitting()">
          {{ t('save') }}
        </button>
      </div>
    </form>
  </app-panel-body>
</ng-container>
